if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
        document.body.appendChild(newDrawer);
        this.fillStockCounts(newDrawer);
        const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector('pickup-availability-drawer').classList.add(colorClass);
        });

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }

      // IO-5852: per-store counts from the Storefront API (see sections/pickup-availability.liquid).
      // Filled as soon as the drawer is rendered, not when it opens: product-main.js clones the list
      // into its own drawer on click, so the counts must already be in it by then. Any failure
      // leaves the spans hidden, which is the drawer without counts.
      fillStockCounts(drawer) {
        const label = drawer && drawer.dataset.stockLabel;
        const variantId = drawer && drawer.dataset.variantId;
        if (!label || !variantId) return;

        let token = window.shopifyStorefrontToken;
        if (!token) {
          try {
            token = JSON.parse(document.getElementById('cart-normalizer-config').textContent).storefrontToken;
          } catch (e) {
            return;
          }
        }
        if (!token) return;

        fetch('/api/2026-04/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({
            query:
              'query($id:ID!){node(id:$id){... on ProductVariant{storeAvailability(first:250){nodes{quantityAvailable location{id}}}}}}',
            variables: { id: 'gid://shopify/ProductVariant/' + variantId },
          }),
        })
          .then((response) => response.json())
          .then((res) => {
            const nodes = res && res.data && res.data.node && res.data.node.storeAvailability
              ? res.data.node.storeAvailability.nodes
              : [];
            const quantities = {};
            nodes.forEach((n) => {
              quantities[String(n.location.id).split('/').pop()] = n.quantityAvailable;
            });
            drawer.querySelectorAll('.pickup-availability-qty[data-location-id]').forEach((span) => {
              const quantity = quantities[span.dataset.locationId];
              if (typeof quantity !== 'number') return;
              span.textContent = label.replace('__QTY__', Math.max(quantity, 0));
              span.hidden = false;
            });
          })
          .catch(() => {});
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
